export default "__VITE_ASSET__ClaQubmr__"